
import { useState, useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";

export const useProductSubscriptions = (productId: string) => {
  const [hasSubscriptions, setHasSubscriptions] = useState(false);
  const [isChecking, setIsChecking] = useState(true);
  const { toast } = useToast();

  useEffect(() => {
    const checkSubscriptions = async () => {
      try {
        // First get all plans for this product
        const { data: plans } = await supabase
          .from('plans')
          .select('id')
          .eq('feature_id', productId);

        if (plans && plans.length > 0) {
          // Then check if any of these plans have active subscriptions
          const planIds = plans.map(plan => plan.id);
          const { data: subscriptions, error } = await supabase
            .from('subscriptions')
            .select('id')
            .in('plan_id', planIds)
            .neq('status', 'cancelled')
            .limit(1);

          if (error) throw error;
          setHasSubscriptions(subscriptions && subscriptions.length > 0);
        }
      } catch (error) {
        console.error('Error checking subscriptions:', error);
        toast({
          title: "Error",
          description: "Failed to check product subscriptions",
          variant: "destructive",
        });
      } finally {
        setIsChecking(false);
      }
    };

    checkSubscriptions();
  }, [productId, toast]);

  return { hasSubscriptions, isChecking };
};
